// TODO: Replace with CMS API response once the GEM Audition Status content endpoint is available.
const GEMAuditionStatusData = {
  appStep: {
    title: "Your Next Step — Download the GEM App",
    subtitle: "The GEM App is required for all further audition updates.",
    loginInstruction:
      "To continue receiving updates regarding your audition submission, download the GEM App and log in using the same Email Address and Password you used during registration.",
  },
  appUpdates: {
    title:
      "Through the GEM App, you will receive important updates related to:",
    points: [
      "Your audition submission",
      "Application status",
      "Shortlisting updates",
      "Physical audition information",
      "Date, time and venue updates",
      "Further instructions from the GEM team",
      "Future talent opportunities",
    ],
  },
  importantNote:
    "Downloading and logging into the GEM App is mandatory to stay updated about the next stages of your audition.",
  alreadyHaveApp: {
    title: "Already Have the GEM App?",
    description:
      "Simply open the app and log in with your registered Email Address and Password to stay connected with your audition journey.",
  },
  nextSteps: {
    title: "What's Next?",
    points: [
      "Your submission will now go through the review process.",
      "If you are shortlisted for the next stage, further information and instructions will be communicated through the GEM App.",
    ],
  },
};

export default GEMAuditionStatusData;
